import React, { useState } from 'react';
import './card.css'; // Import your CSS file

function Card() {
    const data = [
        {
            text: "Living here has been a wonderful experience! The rooms are clean, the meals are delicious, and I always feel safe with 24/7 security and CCTV. The staff is friendly and responsive, making everyday living comfortable and stress-free.",
            name: "Praveen Kumar",
            title: "Resident"
        },
        {
            text: "I really appreciate the attention to hygiene and comfort. The common areas are well-maintained, power backup ensures no interruptions, and the lift makes it easy to move around. It feels like a true home away from home.",
            name: "Saurabh",
            title: "Resident"
        },
        {
            text: "The PG provides everything I need as a working professional—high-speed Wi-Fi, quiet study areas, and home-style meals every day. The security and cleanliness standards are top-notch, and the staff always go the extra mile.",
            name: "Doris ",
            title: "Resident"
        },
        {
            text: "I love staying here! The food is hygienic and tasty, the rooms are spacious and comfortable, and the staff ensures that everything runs smoothly. The sense of community with other residents is also a big plus.",
            name: "Melbin",
            title: "Resident"
        },
        {
            text: "From the cleanliness to the safety measures and the amenities like Wi-Fi, power backup, and lifts, this PG provides a comfortable living experience. I feel well taken care of, and it truly feels like home.",
            name: "Vanshika",
            title: "Resident"
        }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNextClick = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
    };

    const handlePrevClick = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + data.length) % data.length);
    };

    const currentCardData = data[currentIndex];

    return (
        <div className="card-container">
            <div className="card mobile-card-review">
                <p className="card-text">{currentCardData.text}</p>
            </div>
            <div className="card-footer">
                {/* <img className="card-avatar" src={currentCardData.avatar} alt={currentCardData.name} /> */}
                <p className="card-name">{currentCardData.name}</p>
                <p className="card-title">{currentCardData.title}</p>
            </div>

            <div className="card-navigation">
                <img style={{ height: "36px" }} src="./left.png" className="card-button" onClick={handlePrevClick} />
                <img style={{ height: "36px" }} src="./right.png" className="card-button" onClick={handleNextClick} />
            </div>
        </div>
    );
}

export default Card;